import React from 'react';
import { Icon } from 'antd';

const optionsDefault = {
  okText: 'Готово',
  icon: <Icon type="check-circle" theme="filled" />,
  closable: false,
  maskClosable: true,
  centered: true,
  className: 'employee-success-form',
  onOk() {},
  onCancel() {},
};

export const successCreateOrder = (number, name) => ({
  ...optionsDefault,
  title: 'Заказ успешно оформлен!',
  content: `Заказ «${number}» ${(name && '(' + name + ')') ||
    ''} успешно оформлен!`,
});

export const successUpdateOrder = (number, name) => ({
  ...optionsDefault,
  title: 'Изменения успешно сохранены!',
  content: `Изменения успешно внесены в заказ «${number}» ${(name &&
    '(' + name + ')') ||
    ''}!`,
});

export const successArchieveOrder = number => ({
  ...optionsDefault,
  title: 'Заказ успешно отменен!',
  content: `Заказ «${number}» успешно отменен!`,
});

export const successMailSend = email => ({
  ...optionsDefault,
  title: 'Письмо успешно отправлено!',
  content: `Письмо успешно отправлено на e-mail: ${email}`,
});

export const successSetTemplate = name => ({
  ...optionsDefault,
  title: 'Шаблон успешно установлен!',
  content: `Шаблон «${name}» успешно установлен.`,
});
